import _Table from "@material-ui/core/esm/Table";
import _TableBody from "@material-ui/core/esm/TableBody";
import _TableHead from "@material-ui/core/esm/TableHead";
import _TableRow from "@material-ui/core/esm/TableRow";
import _TableCell from "@material-ui/core/esm/TableCell";
import React from 'react';
import classnames from 'classnames';
import { Price } from 'swag-client-common/utils/price';
import classes from './table-price.scss';
export const TablePriceComponent = ({
  prices,
  relatedPrices,
  isOpenRelatedProductsPopup,
  isLimitedEdition
}) => {
  const currentPrices = isOpenRelatedProductsPopup ? relatedPrices : prices;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.table
  }, /*#__PURE__*/React.createElement(_Table, null, /*#__PURE__*/React.createElement(_TableHead, null, /*#__PURE__*/React.createElement(_TableRow, null, /*#__PURE__*/React.createElement(_TableCell, {
    className: classes.tableLeftCell,
    align: "left"
  }, "Qty"), /*#__PURE__*/React.createElement(_TableCell, {
    className: classes.tableMiddleCell,
    align: "right"
  }, "Cost (Each)"), /*#__PURE__*/React.createElement(_TableCell, {
    className: classes.tableRightCell,
    align: "right"
  }, "Saving"))), /*#__PURE__*/React.createElement(_TableBody, null, currentPrices.map((price, index) => /*#__PURE__*/React.createElement(_TableRow, {
    key: index
  }, /*#__PURE__*/React.createElement(_TableCell, {
    className: classes.tableLeftCell,
    align: "left",
    "data-cell": "Quantity"
  }, price.quantity), /*#__PURE__*/React.createElement(_TableCell, {
    align: "right",
    className: classnames(classes.costColumn, classes.tableMiddleCell),
    "data-cell": "Cost"
  }, Price.formatPrice(price.cost)), /*#__PURE__*/React.createElement(_TableCell, {
    align: "right",
    className: classnames(classes.savingColumn, classes.tableRightCell, {
      [classes.orangeColor]: isLimitedEdition
    }),
    "data-cell": "Saving"
  }, Math.round(price.saving * 10) / 10, "%")))))));
};